import {getBreakpoint} from "@front/utils";
import {createComponent} from "@front/utils/alpine";
import Swiper, {Navigation, SwiperOptions, EffectFade, Thumbs} from "swiper";

const imagesSlider = createComponent(() => ({
    init() {

        if (!this.$refs.nav || !this.$refs.cover) {
            //console.warn('References not found for the slider');
            return;
        }

        if (this.$refs.nav.querySelectorAll('.thumb-container').length === 0) {
            //console.warn('No images found for the slider');
            return;
        }

        const navConfig: SwiperOptions = {
            modules: [Navigation],
            navigation: {
                prevEl: this.$refs.navPrev,
                nextEl: this.$refs.navNext,
            },
            slidesPerView: 4,
            spaceBetween: 6,
            slideToClickedSlide: true,
            watchSlidesProgress: true,
            breakpoints: {
                [getBreakpoint('sm')]: {
                    slidesPerView: 5,
                },
                [getBreakpoint('md')]: {
                    slidesPerView: 3,
                },
                [getBreakpoint('lg')]: {
                    slidesPerView: 4,
                },
                [getBreakpoint('xl')]: {
                    slidesPerView: 5,
                }
            }
        }

        const thumbsSwiper = new Swiper(this.$refs.nav, navConfig);

        const coverConfig: SwiperOptions = {
            modules: [EffectFade,Navigation,Thumbs],
            //slideToClickedSlide: true,
            slidesPerView: 1,
            effect: 'fade',
            fadeEffect: {
                crossFade: true,
            },
            loop: true,
            thumbs: {
                swiper: thumbsSwiper,
                slideThumbActiveClass: 'swiper-slide-thumb-active',
            },
            on : {
                init: function() {
                    thumbsSwiper.slideTo(0);
                },
                slideChange: function (swiper) {
                    const activeIndex = swiper.realIndex;
                    thumbsSwiper.slideTo(activeIndex);
                }
            }
        }

        const mainSwiper = new Swiper(this.$refs.cover, coverConfig);

        const thumbs = this.$refs.nav.querySelectorAll('.thumb-container');
        thumbs.forEach((thumb, index) => {
            thumb.addEventListener('click', () => {
                mainSwiper.slideToLoop(index);
            });
        });

    },
}));

export const productSticky = createComponent(() => ({
    fixed: false,
    bottomFixed: false,
    startPos: 0,
    endPos: 0,
    stickyHeight: 0,
    parentHeight: 0,
    resizeScheduled: false,

    init() {
        const { stickyCol, firstCol } = (this as any).$refs as {
            stickyCol: HTMLElement;
            firstCol: HTMLElement;
        };

        const recalcDimensions = () => {
            // get dimensions parent
            const parentRect = firstCol.getBoundingClientRect();
            this.parentHeight = parentRect.height;

            this.stickyHeight = stickyCol.offsetHeight;

            const headerOffset = 80;
            this.startPos = parentRect.top + window.scrollY - headerOffset;

            this.endPos = this.startPos + (this.parentHeight - this.stickyHeight);

            const parentWidth = firstCol.offsetWidth;
            const maxWidth = Math.min(613, parentWidth);
            stickyCol.style.width = `${maxWidth}px`;
        };

        recalcDimensions();

        const resizeObserver = new ResizeObserver(() => {
            if (!this.resizeScheduled) {
                this.resizeScheduled = true;
                requestAnimationFrame(() => {
                    recalcDimensions();
                    // Forzar actualización del estado
                    this.onScroll();
                    this.resizeScheduled = false;
                });
            }
        });
        resizeObserver.observe(firstCol);

        window.addEventListener('resize', () => {
            if (!this.resizeScheduled) {
                this.resizeScheduled = true;
                requestAnimationFrame(() => {
                    recalcDimensions();
                    this.onScroll();
                    this.resizeScheduled = false;
                });
            }
        });
    },

    onScroll() {
        const scrollY = window.scrollY;
        const viewportHeight = window.innerHeight;

        if (scrollY < this.startPos) {
            this.fixed = false;
            this.bottomFixed = false;
        } else if (scrollY >= this.endPos) {
            this.fixed = false;
            this.bottomFixed = true;
        } else {
            this.fixed = true;
            this.bottomFixed = false;
        }
    },
}));



let savedScrollY = 0;

function toggleModal(force: boolean) {
    if (force) {
        if (document.body.style.position === 'fixed') return;
        savedScrollY = window.scrollY;
        document.body.style.position = 'fixed';
        document.body.style.top = `-${savedScrollY}px`;
        document.body.style.width = '100%';
        document.body.style.overflowY = 'hidden';
    } else {
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.width = '';
        document.body.style.overflowY = '';
        window.scrollTo(0, savedScrollY);
    }
    document.querySelector('#main')?.classList.toggle('relative', force);
    document.querySelector('#main')?.classList.toggle('z-[1001]', force);
}

const modal = createComponent(() => ({
    isOpened: false,

    toggle(force: boolean) {
        this.isOpened = force == undefined ? !this.isOpened : force;
    },

    setup() {
        const covers = document.querySelectorAll('.js-customer-img');
        const modalPicture = document.querySelector('.js-customer-modal-picture') as HTMLImageElement;
        const modalCaption = document.querySelector('.js-customer-modal-caption') as HTMLElement;

        toggleModal(this.isOpened);
        this.$watch('isOpened', toggleModal);

        covers.forEach((item) => {
            item.addEventListener('click', (e) => {
                const el = e.target as HTMLImageElement;
                modalPicture.src = el.src;
                modalPicture.alt = el.alt;
                modalCaption.innerHTML = el.alt;

                toggleModal(true);
                this.toggle(true);
            });
        });
    },
}));

const modalCart = createComponent(() => ({
    setup() {
        const modalCart = document.querySelector('.js-product-modal') as HTMLElement;

        document.addEventListener('click', (e) => {
            const target = e.target as HTMLElement;
            const isModal = target.closest('.js-product-modal-inner') as HTMLElement;

            if (!isModal && modalCart.classList.contains('!visible')) {
                modalCart.classList.remove('!visible', '!opacity-100', '!pointer-events-auto');
            }
        });
    }
}));




const photosSlider = createComponent(() => ({
    init() {


        if (!this.$refs.photos) {
            console.warn('References not found for the photo slider');
            return;
        }

        const photoConfig: SwiperOptions = {
            modules: [Navigation],
            navigation: {
                prevEl: this.$refs.photosPrev,
                nextEl: this.$refs.photosNext,
            },
            slidesPerView: 2,
            spaceBetween: 15,
            slideToClickedSlide: true,
            watchSlidesProgress: false,
            breakpoints: {
                [getBreakpoint('sm')]: {
                    slidesPerView: 2,
                },
                [getBreakpoint('md')]: {
                    slidesPerView: 2,
                },
                [getBreakpoint('lg')]: {
                    slidesPerView: 4,
                },
                [getBreakpoint('xl')]: {
                    slidesPerView: 4,
                }
            }
        }

        new Swiper(this.$refs.photos, photoConfig);},
}));

const zoomSlider = createComponent(() => ({
    init() {
        if (!this.$refs.zoomPhotos) {
            return;
        }

        const zoomConfig: SwiperOptions = {
            modules: [Navigation],
            navigation: {
                prevEl: this.$refs.zoomPrev,
                nextEl: this.$refs.zoomNext,
            },
            slidesPerView: 4,
            spaceBetween: 10,
            slideToClickedSlide: true,
            watchSlidesProgress: false,
            breakpoints: {
                [getBreakpoint('sm')]: {
                    slidesPerView: 5,
                },
                [getBreakpoint('md')]: {
                    slidesPerView: 3,
                },
                [getBreakpoint('lg')]: {
                    slidesPerView: 4,
                },
                [getBreakpoint('xl')]: {
                    slidesPerView: 5,
                }
            }
        };

        new Swiper(this.$refs.zoomPhotos, zoomConfig);
    },
}));

const zoomModal = createComponent(() => ({
    isOpened: false,
    images: [] as Array<{src: string, alt: string}>,
    currentIndex: 0,

    toggle(force: boolean) {
        this.isOpened = force == undefined ? !this.isOpened : force;
    },

    prev() {
        this.currentIndex = (this.currentIndex - 1 + this.images.length) % this.images.length;
        this._updateModalPicture();
    },

    next() {
        this.currentIndex = (this.currentIndex + 1) % this.images.length;
        this._updateModalPicture();
    },

    _updateModalPicture() {
        const modalPicture = document.querySelector('.js-zoom-modal-picture') as HTMLImageElement;
        if (modalPicture && this.images[this.currentIndex]) {
            modalPicture.src = this.images[this.currentIndex].src;
            modalPicture.alt = this.images[this.currentIndex].alt;
        }
    },

    setup() {
        const zoomImages = document.querySelectorAll('.js-zoom-img');
        const modalPicture = document.querySelector('.js-zoom-modal-picture') as HTMLImageElement;

        this.images = Array.from(zoomImages).map((img) => {
            const el = img as HTMLImageElement;
            return {
                src: el.dataset.zoomUrl || el.dataset.src || el.src,
                alt: el.alt,
            };
        });

        toggleModal(this.isOpened);
        this.$watch('isOpened', toggleModal);

        zoomImages.forEach((item, index) => {
            item.addEventListener('click', (e) => {
                const el = e.target as HTMLImageElement;
                this.currentIndex = index;
                modalPicture.src = el.dataset.zoomUrl || el.dataset.src || el.src;
                modalPicture.alt = el.alt;

                toggleModal(true);
                this.toggle(true);
            });
        });
    },
}));


export default {
    photosSlider,
    imagesSlider,
    productSticky,
    modal,
    modalCart,
    zoomSlider,
    zoomModal,
};